import Api from "@core/api";
import { BaseError } from "@core/interfaces/network/BaseError";
import { isNil } from "lodash";
interface Error {
  error: any;
  defaultMessage?: string;
  defaultStatusCode?: number;
}

class ApiLaw extends Api {
  parseErpErrorMessage = ({ error, defaultMessage }: BaseError) => {
    if (!isNil(error)) {
      if (error?.data?.message) return error?.data?.message;
      if (error?.message) return error.message;
    }
    return defaultMessage;
  };

  parseErpErrorCode = ({ error, defaultStatusCode = 404 }: BaseError) => {
    if (!isNil(error)) {
      return error.code;
    }
    return defaultStatusCode;
  };

}

export default new ApiLaw(process.env.LAW_API_BASE_URL!);
